<template>
    <div>
        <table class="table table-hover">
            <tr v-for="store in stores">
                <td>
                    <ToggleModel active="bg-primary" v-model="selectedStores[store.id]"/>
                </td>
                <td>{{ store.attributes.name }}</td>
                <td>{{ store.attributes.address.street1 }}</td>
            </tr>
        </table>
        <div>
            <button class="btn btn-primary" @click="linkStores" :disabled="selectedToEnable.length === 0">
                <i class="fas fa-link"/>
                {{ __('actions.store.activate_chosen_multiple') }}
            </button>
        </div>
    </div>
</template>

<script>
import ToggleModel from "../ToggleModel.vue";

export default {
    components: {ToggleModel},

    props: {
        integration: Object,
        stores: {
            types: [Object, Array]
        }
    },

    data() {
        return {
            selectedStores: {}
        }
    },

    methods: {
        linkStores() {
            if (this.selectedToEnable.length === 0) {
                return
            }

            this.$inertia.visit(this.$route('integration.store.config', {
                integration: this.integration.code,
                storeUuid: this.selectedToEnable,
                action: 'link'
            }))
        },
    },

    computed: {
        selectedToEnable() {
            let out = []
            for (let selected in this.selectedStores) {
                if (this.selectedStores[selected]) {
                    out.push(selected)
                }
            }
            return out
        },
    }
}
</script>
